/**
*
* useDeleteMessage
*
*/

import useAuthorizedRequest from 'containers/Api2/useAuthorizedRequest.js';
import { deleteItem } from 'utils/useApi3/reduceObjects.js';
import useUpdateTopics from '../useUpdateTopics.js';
import useConversationsContext from '../useConversationsContext.js';

function useDeleteMessage(topicId) {
  const { authFetch } = useAuthorizedRequest();
  const { baseUrl, setInTopics, topics, setTopics } = useConversationsContext();
  const updateTopics = useUpdateTopics({ baseUrl, topics, setTopics });
  async function deleteMessage(messageId) {
    const url = `${baseUrl}/${topicId}/messages/${messageId}`;
    await authFetch({ url, method: 'DELETE', noReport: [401, 500] });
    setInTopics([topicId, 'messages'], deleteItem(messageId));
    updateTopics();
  }
  return deleteMessage;
}

export default useDeleteMessage;
